module.exports = __webpack_public_path__ + "static/media/terms.11664eed.pdf";